/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/



import {createStore, combineReducers, applyMiddleware} from "redux";

import thunk from 'redux-thunk';


import LocalizationReducer from "@Reducers/Localization";
import AuthenticationReducer from "@Reducers/Authentication";
import InterfaceReducer from "@Reducers/Interface";
import ApiReducer from "@Reducers/Api";


export type ApplicationStateInterface = {
    localization: typeof LocalizationReducer;
    authentication: typeof AuthenticationReducer;
    interface: typeof InterfaceReducer;
    api: typeof ApiReducer;
}


const ApplicationReducer = combineReducers<ApplicationStateInterface>({
    localization: LocalizationReducer,
    authentication: AuthenticationReducer,
    interface: InterfaceReducer,
    api: ApiReducer
});


const ApplicationStore = createStore(
    ApplicationReducer, {}, applyMiddleware(thunk)
);


export default ApplicationStore;
